// extracted by mini-css-extract-plugin
export var gif = "_kc-0";